'use strict';

const Artesano = angular
    .module('app.artesano', [

    ])
    .name;

export default Artesano;


// WEBPACK FOOTER //
// ./src/app/components/probolivia/artesano/artesano.module.js